import { render, staticRenderFns } from "./newOaWorkflowPool.vue?vue&type=template&id=68351e8e&scoped=true"
import script from "./newOaWorkflowPool.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowPool.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowPool.vue?vue&type=style&index=0&id=68351e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68351e8e",
  null
  
)

export default component.exports